import { render, staticRenderFns } from "./GroupsViewer.vue?vue&type=template&id=7e4fcaff&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&xmlns%3Av-scroll=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml"
import script from "./GroupsViewer.vue?vue&type=script&lang=js"
export * from "./GroupsViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4fcaff",
  null
  
)

export default component.exports